export const GET_PAY_LATER_DATA =  'GET_PAY_LATER_DATA'
export const SET_PAY_LATER_DATA =  'SET_PAY_LATER_DATA'
export const GET_PAYLATER_STATUS_DATA =  'GET_PAYLATER_STATUS_DATA'
export const GET_PAYLATER_STATUS_DATA_SUCCESS =  'GET_PAYLATER_STATUS_DATA_SUCCESS'
export const GET_USER_STATUSES_FOR_FINANCE_FIRST_STEP = "GET_USER_STATUSES_FOR_FINANCE_FIRST_STEP"
export const STORE_USER_EMAIL = "STORE_USER_EMAIL"
export const STORE_VERIFICATION_CODE = "STORE_VERIFICATION_CODE"